import { cars } from "./cars"
import { motorcycles } from "./motorcycles"

export const segments = {
  'AU': {
    data: cars,
    title: 'Carros'
  },
  'MO': {
    data: motorcycles,
    title: 'Motos'
  },
}